import React from 'react';
import { Link } from 'react-router-dom';
import * as LucideIcons from 'lucide-react';
import { services, paymentMethods } from '../mock';
import { ArrowRight, Banknote, Car, Wifi, PartyPopper } from 'lucide-react';

function Icon({ name, size = 24 }) {
  const I = LucideIcons[name] || LucideIcons.Circle;
  return <I size={size}/>;
}

export default function Services() {
  return (
    <div className="bg-[#faf6f0] pt-32 pb-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-amber-600 tracking-[0.3em] text-xs uppercase">Was wir bieten</span>
          <h1 className="font-serif text-5xl md:text-6xl text-[#1a1410] mt-4">Unsere Services</h1>
          <div className="w-16 h-[3px] bg-amber-500 mx-auto mt-6"/>
          <p className="text-[#5a4a3d] max-w-2xl mx-auto mt-6">
            Von der Tischreservierung bis zum privaten Event — wir kümmern uns um alles, damit Sie einen entspannten Aufenthalt genießen können.
          </p>
        </div>

        {/* Highlight cards */}
        <div className="grid md:grid-cols-2 gap-6 mb-20">
          <div className="bg-gradient-to-br from-[#1a1410] to-[#2a1e15] text-white rounded-2xl p-10 relative overflow-hidden group">
            <div className="absolute -right-10 -bottom-10 opacity-10 group-hover:opacity-20 transition-opacity">
              <PartyPopper size={200}/>
            </div>
            <span className="text-amber-400 tracking-[0.3em] text-xs uppercase">Tisch reservieren</span>
            <h2 className="font-serif text-3xl md:text-4xl mt-3">Ihr Tisch wartet</h2>
            <p className="mt-4 text-amber-50/85">Reservieren Sie bequem online oder telefonisch. Unser Team empfängt Sie herzlich — mit oder ohne Anlass.</p>
            <Link to="/kontakt" className="inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-full bg-amber-500 hover:bg-amber-400 text-[#1a1410] font-semibold transition-colors">
              Jetzt reservieren <ArrowRight size={18}/>
            </Link>
          </div>

          <div className="bg-white rounded-2xl p-10 border border-amber-100 shadow-sm">
            <span className="text-amber-600 tracking-[0.3em] text-xs uppercase">Zahlungsmöglichkeiten</span>
            <h2 className="font-serif text-3xl md:text-4xl mt-3 text-[#1a1410]">Bezahlung</h2>
            <p className="mt-4 text-[#5a4a3d]">Bei uns können Sie sowohl bar als auch bequem mit Karte bezahlen — ganz nach Ihrem Wunsch.</p>
            <div className="mt-6 space-y-3">
              {paymentMethods.map((p) => (
                <div key={p.id} className="flex items-center gap-4 p-4 rounded-lg bg-amber-50/60 border border-amber-100">
                  <div className="w-11 h-11 rounded-full bg-amber-500 text-white flex items-center justify-center"><Icon name={p.icon} size={20}/></div>
                  <div>
                    <div className="font-semibold text-[#1a1410]">{p.name}</div>
                    <div className="text-sm text-[#5a4a3d]">{p.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Feature grid */}
        <h3 className="font-serif text-2xl text-[#1a1410] text-center mb-2">Zusätzliche Annehmlichkeiten</h3>
        <p className="text-center text-[#5a4a3d] mb-10">Alles, was Sie für einen angenehmen Aufenthalt brauchen</p>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {services.map((s) => (
            <div key={s.id} className="bg-white rounded-xl p-6 text-center shadow-sm border border-amber-100/60 hover:border-amber-400 hover:shadow-xl hover:-translate-y-1 transition-all group">
              <div className="mx-auto w-14 h-14 rounded-full bg-amber-50 group-hover:bg-amber-500 text-amber-700 group-hover:text-white flex items-center justify-center mb-3 transition-colors">
                <Icon name={s.icon} size={22}/>
              </div>
              <div className="font-serif text-[#1a1410] text-sm">{s.title}</div>
              <div className="text-xs text-[#5a4a3d] mt-2 leading-relaxed">{s.desc}</div>
            </div>
          ))}
        </div>

        {/* Parking + Wifi highlight */}
        <div className="mt-16 grid md:grid-cols-2 gap-6">
          <div className="bg-white rounded-2xl p-8 flex items-start gap-5 border border-amber-100">
            <div className="w-14 h-14 rounded-full bg-amber-500 text-white flex items-center justify-center shrink-0"><Car size={24}/></div>
            <div>
              <h3 className="font-serif text-2xl text-[#1a1410]">Eigene Parkplätze</h3>
              <p className="text-[#5a4a3d] mt-2">Kostenlose Parkmöglichkeiten direkt vor dem Lokal. Kommen Sie bequem mit dem Auto — auch für größere Gruppen.</p>
            </div>
          </div>
          <div className="bg-white rounded-2xl p-8 flex items-start gap-5 border border-amber-100">
            <div className="w-14 h-14 rounded-full bg-amber-500 text-white flex items-center justify-center shrink-0"><Wifi size={24}/></div>
            <div>
              <h3 className="font-serif text-2xl text-[#1a1410]">Kostenloses WLAN</h3>
              <p className="text-[#5a4a3d] mt-2">Für alle Gäste steht kostenloses WLAN zur Verfügung — bleiben Sie verbunden, während Sie genießen.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
